/***
*
*   FOOTER (homepage)
*   Static homepage footer
*
**********/
import { Animate, Link, useTranslation } from 'components/lib'
import Style from './footer.module.scss';
import FeatherIcon from 'feather-icons-react';


export function Footer(props) {

    const { t } = useTranslation();

    const socials =
    {
        "linkedin": "https://www.linkedin.com/company/82829790/admin/feed/posts/",
        "faceBook": "https://business.facebook.com/latest/home?business_id=507419197885630&asset_id=101942162718471&mio=false&launch_notifications=false&nav_ref=bizweb_landing_fb_login_button&biz_login_source=bizweb_landing_fb_login_button#_=_",
        "twitter": "https://twitter.com/TopGrep",
        "youtube": "https://www.youtube.com/@topgrep9191",
        "mobileNumber": 8971131578,
        "email": "resolutions@topgrep.com"
    }

    return (
        <Animate type='slideup'>
            <footer className={Style.footer}>
                <div id='footerTop' className={Style.footerTop}>
                    <FeatherIcon
                        color='white'
                        icon='arrow-up'
                        onClick={() => {
                            if (typeof window !== 'undefined') {
                                window.scrollTo(0, 0);
                            }
                        }}
                    />
                    <span className={Style.mobileNumber}>
                        <p>
                            {t('global.footer.contactUpper')}
                        </p>
                        <p>
                            {socials.mobileNumber}
                        </p>
                    </span>
                    <span>
                        <p>
                            {t('global.footer.email')}
                        </p>
                        <p>
                            {socials.email}
                        </p>
                    </span>
                    <span>
                        <p>
                            {t('global.footer.social')}
                        </p>
                        <div id='socialsContainer' className={Style.socialsContainer}>
                            <FeatherIcon
                                color='white'
                                icon='facebook'
                                onClick={() => {
                                    window.open(socials.faceBook, '_blank');
                                }}
                            />
                            <FeatherIcon
                                color='white'
                                icon='linkedin'
                                onClick={() => {
                                    window.open(socials.linkedin, '_blank');
                                }}
                            />
                            <FeatherIcon
                                color='white'
                                icon='twitter'
                                onClick={() => {
                                    window.open(socials.twitter, '_blank');
                                }}
                            />
                            <FeatherIcon
                                color='white'
                                icon='youtube'
                                onClick={() => {
                                    window.open(socials.youtube, '_blank');
                                }}
                            />
                        </div>
                    </span>
                    <div className={Style.logoWrapper}>
                        <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/website/logo-dark-short.png`} alt='AIVAGAM | A Platform to Test the Testers' />
                    </div>
                </div>
                <div className={Style.divider} />
                <div className={Style.footerBottom}>
                    <div className={Style.copyright}>{t('global.footer.copyright', { year: new Date().getFullYear() })}</div>
                    <Link url='/terms' className={Style.address} color='white'>{t('global.footer.powered')}</Link>
                    <span>
                        <Link url='/privacy' className={Style.link} color='white'>{t('global.footer.privacy')}</Link> | <Link url='/contact' className={Style.link} color='white'>{t('global.footer.contact')}</Link>
                    </span>
                </div>
            </footer>
        </Animate>
    );
}